"use client";
import Image from "next/image";
import Link from "next/link";
import { Stack, SimpleGrid, Box } from "@chakra-ui/react";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { Heading } from "@/elements";
import { CUSTOMER_CONSTANTS, CUSTOMERS_LIST } from "./ourCustomers.constants";

const OurCustomers = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Stack gap={10}>
      <Heading as="h2" variant={HeadingVariant} textAlign={"center"} px={2}>
        {CUSTOMER_CONSTANTS.TITLE}
      </Heading>
      <Stack borderRadius={"8px"} className="brand-shadow" gap={8} py={10}>
        <SimpleGrid
          columns={{ base: 6, md: 8 }}
          columnGap={{ base: 3, sm: 4, md: 5 }}
          justifyContent={"center"}
          alignItems={"center"}
          rowGap={10}
          p={{ base: 3, md: 5 }}
        >
          {CUSTOMERS_LIST.map((customer, index) => {
            return (
              <Link
                key={index}
                href={customer.href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Box
                  position="relative"
                  maxW="130px"
                  width="100%"
                  height="65px"
                  _hover={{ transform: "scale(1.05)" }}
                  transition="transform 0.2s"
                >
                  <Image
                    src={customer.image}
                    alt={customer.name}
                    fill
                    sizes="(min-width: 62em) 130px, (min-width: 30em) 100px, 80px"
                    style={{ objectFit: "contain", objectPosition: "center" }}
                    loading="lazy"
                  />
                </Box>
              </Link>
            );
          })}
        </SimpleGrid>
      </Stack>
    </Stack>
  );
};

export default OurCustomers;
